var _rect, _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetAsPrimaryDiagnosisIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 8.00158C15.0001 9.53553 14.4959 11.0269 13.5654 12.2464C12.6349 13.4658 11.3295 14.3459 9.85011 14.7512C8.37068 15.1565 6.79907 15.0647 5.37694 14.4898C3.9548 13.9148 2.76088 12.8887 1.97876 11.5691C1.19664 10.2496 0.869616 8.7096 1.04798 7.18605C1.22635 5.66251 1.90022 4.23974 2.96599 3.1365C4.03176 2.03326 5.43041 1.31064 6.94688 1.07976C8.46335 0.848873 10.0137 1.12251 11.3595 1.85858",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 11.0019C9.65734 11.0019 11.0005 9.6588 11.0005 8.00195C11.0005 6.3451 9.65734 5.00195 8.00049 5.00195C6.34363 5.00195 5.00049 6.3451 5.00049 8.00195C5.00049 9.6588 6.34363 11.0019 8.00049 11.0019Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00049,
    cy: 8,
    r: 3.5,
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 5.00097C14.1051 5.00097 15.0005 4.10554 15.0005 3.00098C15.0005 1.89641 14.1051 1.00098 13.0005 1.00098C11.8959 1.00098 11.0005 1.89641 11.0005 3.00098C11.0005 4.10554 11.8959 5.00097 13.0005 5.00097Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetAsPrimaryDiagnosisIcon);
export default __webpack_public_path__ + "static/media/setAsPrimaryDiagnosisIcon.f13abe31ec51da9bbb4d780ff9a1890b.svg";
export { ForwardRef as ReactComponent };